
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import SEO from '@/components/SEO';

const Glossary = () => {
  const glossaryTerms = [
    {
      term: "Digital suveränitet",
      definition: "Möjligheten att ha fullständig kontroll över sin digitala närvaro, data och digitala öde. Det innebär frihet från beroenden av specifika leverantörer eller teknologier."
    },
    {
      term: "Öppen källkod",
      definition: "Programvara vars källkod är tillgänglig för alla att se, använda, modifiera och distribuera. Detta möjliggör granskning av koden för säkerhets- och integritetsproblem."
    },
    {
      term: "Kryptering",
      definition: "Processen att koda information så att obehöriga inte kan läsa den. End-to-end-kryptering betyder att bara avsändaren och mottagaren kan läsa meddelandena."
    },
    {
      term: "GDPR",
      definition: "General Data Protection Regulation, EU:s dataskyddsförordning som reglerar hur personuppgifter får samlas in och behandlas."
    },
    {
      term: "Dataminimering",
      definition: "Principen att endast samla in och lagra den data som är absolut nödvändig för att uppfylla ett specifikt syfte."
    },
    {
      term: "Federerad tjänst",
      definition: "En decentraliserad nätverkstjänst där flera oberoende servrar kan kommunicera med varandra. Exempel inkluderar Mastodon och Matrix."
    },
    {
      term: "Proprietär programvara",
      definition: "Program vars källkod inte är öppet tillgänglig och ofta inkluderar begränsningar för hur användare får använda mjukvaran."
    },
    {
      term: "VPN",
      definition: "Virtual Private Network, en tjänst som krypterar din internetanslutning och döljer din IP-adress för att öka din integritet och säkerhet online."
    },
    {
      term: "End-to-end-kryptering",
      definition: "En säker kommunikationsmetod där endast kommunicerande användare kan läsa meddelandena. Inte ens tjänsteleverantören kan se innehållet."
    },
    {
      term: "Digital fingeravtryck",
      definition: "Den unika uppsättning information som din enhet lämnar när du surfar på nätet, vilket kan användas för att spåra och identifiera dig."
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Digital Ordlista - Frikopplad"
        description="Förstå begreppen: En ordlista över viktiga termer inom digital suveränitet och integritet."
        url="/ordlista"
      />
      <Navbar />
      <main className="flex-grow">
        <div className="container-custom py-12">
          <h1 className="text-3xl md:text-4xl font-bold text-frikopplad-navy mb-4">Digital Ordlista</h1>
          <p className="text-lg text-gray-700 mb-8">
            Här förklarar vi viktiga begrepp inom digital frihet och integritet för att hjälpa dig förstå 
            de olika aspekterna av att ta kontroll över ditt digitala liv.
          </p>
          
          <div className="bg-white rounded-lg shadow p-6">
            <Accordion type="single" collapsible className="w-full">
              {glossaryTerms.map((item, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-lg font-medium text-frikopplad-navy hover:text-frikopplad-red">
                    {item.term}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-700">
                    <p>{item.definition}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Glossary;
